import {Link} from "@tanstack/react-router";

interface BreadcrumbsProps {
    pageTitle: string
}
export default function Breadcrumbs({pageTitle}: BreadcrumbsProps) {
 const hostname = `https://${window.location.hostname}`;

 //Use window.location.hostname for Home so that it prints the correct value
 //for Pantheon multidev environments

    return (
        <div className="Breadcrumbs">
                            <span>
                                <span>
                                    <a href={hostname}>Home</a>
                                </span>
                                <span className="Breadcrumbs__separator">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="19"><path
                                        d="m8.889 8.527-5.171 8.528A15.567 15.567 0 0 1 0 15.333l4.128-6.806L0 1.722A15.735 15.735 0 0 1 3.718 0l5.17 8.527Z"></path></svg>
                                </span>
                                <span>
                                    <Link to="/">Policy Library</Link>
                                </span>
                                     <span className="Breadcrumbs__separator">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="19"><path
                                        d="m8.889 8.527-5.171 8.528A15.567 15.567 0 0 1 0 15.333l4.128-6.806L0 1.722A15.735 15.735 0 0 1 3.718 0l5.17 8.527Z"></path></svg>
                                </span>
                                <span className="breadcrumb__last" aria-current="page">
                                   {pageTitle ? pageTitle : "Policy"}
                                </span>
                            </span>
        </div>
    );
}